<div class="w-full border border-grey-veryLight rounded-xl p-2">
	<h4>Terms</h4>
	<div class="flex items-start gap-5 w-full">
		<div class="flex flex-col flex-1">
			<div class="flex gap-3">
				<app-input
					class="mt-5"
					label="Principal amount"
					[startIcon]="ICON.DOLLAR"
					[ngModel]="_mortgage.amount"
					(ngModelChange)="setAmount($event)"
					type="cents"
				></app-input>
			</div>
		</div>

		<div class="flex flex-col bg-grey-lightest rounded-xl p-2">
			<app-checkbox
				type="clear"
				[ngModel]="_mortgage.assignmentOfRents"
				(ngModelChange)="setAssignmentOfRents($event)"
				>Assignment of rents</app-checkbox
			>
			<div class="my-2">
				<app-checkbox
					type="clear"
					[ngModel]="_mortgage.generalSecurityAgreement"
					(ngModelChange)="setGeneralSecurityAgreement($event)"
					>General security agreement</app-checkbox
				>
			</div>
		</div>
	</div>

	<div class="flex gap-3 rounded-xl bg-grey-lightest mt-5 p-2">
		<app-radio-group
			label="Interest rate type"
			type="compact"
			[items]="interestRateTypeOptions"
			[ngModel]="_mortgage.interestRateType"
			(ngModelChange)="setInterestRateType($event)"
		></app-radio-group>
		<app-input
			label="Interest rate per annum"
			type="number"
			[endIcon]="ICON.PERCENTAGE"
			[ngModel]="_mortgage.interestRate"
			(debounce)="setInterestRate($event)"
		></app-input>
		<app-dropdown
			label="Interest calculated"
			[itemGroups]="[{ items: interestCalculatedOptions }]"
			[readonly]="false"
			[ngModel]="_mortgage.interestCalculated"
			(debounce)="setInterestCalculated($event)"
			(onSelect)="selectInterestCalculated($event)"
		></app-dropdown>
	</div>
	<app-checkbox
		[(ngModel)]="overrideInterestForReg"
		type="clear"
		class="mt-3"
		(ngModelChange)="setOverrideInterestForEReg($event)"
		>Override interest details for registration</app-checkbox
	>

	<div
		*ngIf="overrideInterestForReg"
		[@openClose]
		class="flex items-end p-2 pt-3 rounded-xl bg-grey-lightest gap-3"
	>
		<app-input
			label="Interest rate type as registered"
			[ngModel]="_mortgage.interestRateTypeAsReg"
			(debounce)="setRateTypeAsReg($event)"
		></app-input>
		<app-input
			label="Interest rate per annum as registered"
			[ngModel]="_mortgage.interestRateAsReg"
			(debounce)="setRateAsReg($event)"
		></app-input>
		<app-input
			label="Interest calculated as registered"
			[ngModel]="_mortgage.interestCalculatedAsReg"
			(debounce)="setInterestCalculatedAsReg($event)"
		></app-input>
	</div>

	<div class="flex p-2 mt-5 bg-grey-lightest gap-3"></div>

	<div class="flex">
		<app-radio-group
			class="mt-5"
			label="Insurance amount"
			type="compact"
			[items]="insuranceAmountOptions"
			[ngModel]="_mortgage.insuranceAmount"
			(ngModelChange)="setInsuranceAmount($event)"
		></app-radio-group>
	</div>
</div>
